import { useLocation } from "react-router-dom";
import { useState } from "react";
import { Pivot, PivotItem } from "@fluentui/react";
import PortalTaskView from "./views/portalTaskView";
import PortalTodoView from "./views/portalTodoView";

const PortalContent = () => {
  const location = useLocation();
  const { portal } = location.state || {};
  const dataSources = portal?.dataSources || [];

  const [selectedTab, setSelectedTab] = useState(dataSources[0]?.name || "default");

  // Get the currently selected data source
  const currentDataSource = dataSources.find(ds => ds.name === selectedTab) || dataSources[0];
  const id = currentDataSource?.id;
  const responseType = currentDataSource?.responseType;

  return (
    <div className="teams-card">
      <h3>Task List</h3>

      {dataSources.length > 1 ? (
        <>
          <Pivot
            selectedKey={selectedTab}
            onLinkClick={(item) => {
              if (item?.props?.itemKey) {
                setSelectedTab(item.props.itemKey);
              }
            }}
            headersOnly={true}
          >
            {dataSources.map((dataSource) => (
              <PivotItem
                key={dataSource.id || dataSource.name}
                headerText={dataSource.name}
                itemKey={dataSource.name}
              />
            ))}
          </Pivot>

          {responseType === 1 ? (
            <PortalTaskView key={id} id={id} />
          ) : (
            <PortalTodoView key={id} id={id} />
          )}
        </>
      ) : responseType === 1 ? (
        <PortalTaskView id={id} />
      ) : (
        <PortalTodoView id={id}  />
      )}
    </div>
  );
};

export default PortalContent;
